<template>
  <div class="about">
    <div class="container">
      <div class="about-image">
        <img src="~@/assets/banner-hero.png" alt="about" />
        <div class="hero-mask"></div>
        <h1>Sobre o Dez Noventa</h1>
      </div>
      <p>
        O DezNoventa é o portal de vendas dos imóveis de propriedade dos fundos
        de investimento geridos pela Ulbrex Asset. Ao longo dos últimos 3 anos,
        vendemos mais de 1.500 imóveis em todo o Brasil.
      </p>

      <br />

      <p>
        Aqui você encontra imóveis residenciais e comerciais prontos,
        selecionados por nossa equipe de forma criteriosa e com preços e
        condições de pagamento imperdíveis.
      </p>

      <br />

      <p>
        A Ulbrex Asset é uma gestora de recursos de terceiros especializada no
        mercado imobiliário e devidamente regulamentada pela Comissão de Valores
        Mobiliários – CVM. Para mais informações a nosso respeito, acesse
        <a href="http://www.ulbrex.com.br" target="_blank">www.ulbrex.com.br</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",

  setup() {}
};
</script>

<style lang="scss" scoped>
.about {
  margin: 0 auto;
  min-height: 200px;

  .container {
    display: flex;
    height: 100%;
    flex-direction: column;
    max-width: 1200px;
    position: relative;
    margin-top: 150px;

    .about-image {
      width: 100%;
      min-height: 520px;
      display: flex;
      border-radius: 50px;
      padding: 80px;
      margin-bottom: 58px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50px;
        height: 520px;
        width: 100%;
        object-fit: cover;
        z-index: 0;
      }

      h1 {
        max-width: 500px;
        color: var(--white);
        line-height: 70px;
        font-size: var(--size-h1);
        font-weight: var(--weight-bold);
        font-family: var(--font-primary);
        padding-bottom: 80px;
        z-index: 1;
      }

      .hero-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 520px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50px;
      }
    }

    p {
      font-size: var(--size-large);
      font-weight: var(--weight-light);
      font-family: var(--font-primary);
      line-height: 38px;
      color: #414f54;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    padding: 0 50px 0 50px;
  }
}
</style>
